// src/stores/ads.js
import { defineStore } from 'pinia'
import { adApi } from '@/api'

export const useAdsStore = defineStore('ads', {
    state: () => ({
        bannerAds: [],
        ads: [],
        loading: false,
        lastUpdateDate: null,
        adsCategory: [],
        currentAd: null,
        categoryAdCache: {
            list: null,         // 缓存的广告列表
            category: null,     // 当前缓存的分类
            pagination: {       // 分页信息
                currentPage: 1,
                hasMore: true,
                pageSize: 10
            }
        }
    }),

    actions: {
        // 获取广告数据
        async fetchAds() {
            this.loading = true
            try {
                const res = await adApi.getHomeAds()
                this.bannerAds = res.bannerAds
                this.ads = res.ads
                this.lastUpdateDate = new Date().toDateString()
            } catch (error) {
                console.error('获取广告失败:', error)
            } finally {
                this.loading = false
            }
        },
        // 获取分类
        async getAdsCategorys() {
            try {
                const response = await adApi.getAdsCategorys();
                this.adsCategory = response;
            } catch (error) {
                console.error("获取分类失败:", error);
            }
        },
        // 检查是否需要更新
        async checkForUpdates() {
            await this.fetchAds()
            await this.getAdsCategorys()
            const today = new Date().toDateString()
            if (this.lastUpdateDate !== today) {
                await this.fetchAds()
            }
        },

       

        // 新增: 更新广告点击数
        async updateAdClick(adId) {
            try {
                // 调用 API 更新数据库
                await adApi.updateAdClick(adId)
                
                // 更新本地 store 中的点击数
                this.ads = this.ads.map(category => ({
                    ...category,
                    ads: category.ads.map(ad => {
                        if (ad._id === adId) {
                            return {
                                ...ad,
                                clickCount: (ad.clickCount || 0) + 1
                            }
                        }
                        return ad
                    })
                }))
            } catch (error) {
                console.error('更新点击数失败:', error)
            }
        },
        // 新增: 更新 banner 广告点击数
        async updateBannerAdClick(adId) {
            try {
                await adApi.updateAdClick(adId)
                
                // 只更新 bannerAds 中的点击数
                this.bannerAds = this.bannerAds.map(ad => {
                    if (ad._id === adId) {
                        return {
                            ...ad,
                            clickCount: (ad.clickCount || 0) + 1
                        }
                    }
                    return ad
                })
            } catch (error) {
                console.error('更新banner广告点击数失败:', error)
            }
        },
       // 更新分类缓存中广告的点击数
        async updateCategoryAdClick(adId) {
            try {
                // 调用 API 更新数据库
                await adApi.updateAdClick(adId)
                
                // 只更新缓存中的点击数
                if (this.categoryAdCache.list) {
                    this.categoryAdCache.list = this.categoryAdCache.list.map(ad => {
                        if (ad._id === adId) {
                            return {
                                ...ad,
                                clickCount: (ad.clickCount || 0) + 1
                            }
                        }
                        return ad
                    })
                }
            } catch (error) {
                console.error('更新分类广告点击数失败:', error)
            }
        },
        // 新增: 根据 ID 查找广告
        // 在组件中使用时，根据广告类型调用对应的方法
        findAdById(adId) {
            // 先在 bannerAds 中查找
            const bannerAd = this.bannerAds.find(ad => ad._id === adId)
            if (bannerAd) return bannerAd
            
            // 再在普通广告中查找
            for (const category of this.ads) {
                const ad = category.ads.find(ad => ad._id === adId)
                if (ad) return ad
            }
            return null
        },

       

        // 新增: 缓存相关的 actions
        setCategoryAdList(list, category) {
            this.categoryAdCache.list = list
            this.categoryAdCache.category = category
        },

        updateCategoryPagination(currentPage, hasMore) {
            this.categoryAdCache.pagination = {
                ...this.categoryAdCache.pagination,
                currentPage,
                hasMore
            }
        },
        clearCategoryCache() {
            this.categoryAdCache = {
                list: null,
                category: null,
                pagination: {
                    currentPage: 1,
                    hasMore: true,
                    pageSize: 10
                }
            }
        },
         // 获取缓存的分类广告列表
         getCachedCategoryAds(category) {
            if (this.categoryAdCache.category === category) {
                return {
                    list: this.categoryAdCache.list,
                    pagination: this.categoryAdCache.pagination
                }
            }
            return null
        },

        // 添加新广告到缓存列表
        appendToCategoryCache(newAds) {
            if (this.categoryAdCache.list) {
                this.categoryAdCache.list = [...this.categoryAdCache.list, ...newAds]
            }
        },
         // 重置状态
         reset() {
            this.bannerAds = []
            this.ads = []
            this.loading = false
            this.lastUpdateDate = null
            this.clearCategoryCache()
        },
         // 新增: 设置当前广告
         setCurrentAd(ad) {
            this.currentAd = ad
        },
    },

    persist: {
        key: 'ads',
        storage: localStorage,
        paths: [
            'bannerAds', 
            'ads', 
            'lastUpdateDate',
            'categoryAdCache' // 添加缓存到持久化列表
        ]
    }
})